/**
 * Shopify Storefront API Apollo Client
 * Provides GraphQL client instance for Storefront API queries and mutations
 */

import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core'
import { globalState } from '@/components/helpers/utils'

let _storefront: ApolloClient<any> | null = null

export const storefront = {
  get client() {
    if (!_storefront) {
      if (!globalState?.apis?.graphQlEndpoint) {
        throw new Error('Global state not available or missing API configuration')
      }

      const storefrontLink = createHttpLink({
        uri: globalState.apis.graphQlEndpoint,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Shopify-Storefront-Access-Token': globalState.apis.storefrontAccessToken
        }
      })

      _storefront = new ApolloClient({
        link: storefrontLink,
        cache: new InMemoryCache()
      })
    }
    return _storefront
  },

  query: (options: any) => storefront.client.query(options),
  mutate: (options: any) => storefront.client.mutate(options),
  watchQuery: (options: any) => storefront.client.watchQuery(options)
}
